/**
 * @fileoverview gRPC-Web generated client stub for dialerepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/dialer/nxExtenManage.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_dialer_pb = require('../../xcommon/dialer_pb.js')

var xcommon_common_pb = require('../../xcommon/common_pb.js')

var xcommon_nxExtenManage_pb = require('../../xcommon/nxExtenManage_pb.js')

var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js')
const proto = {};
proto.dialerepb = require('./nxExtenManage_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dialerepb.NxExtenManageServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dialerepb.NxExtenManageServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.XExtenListReq,
 *   !proto.xcommon.ExtenListResp>}
 */
const methodDescriptor_NxExtenManageService_GetExtenList = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/GetExtenList',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.XExtenListReq,
  xcommon_nxExtenManage_pb.ExtenListResp,
  /**
   * @param {!proto.xcommon.XExtenListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_nxExtenManage_pb.ExtenListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.XExtenListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.ExtenListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ExtenListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.getExtenList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/GetExtenList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_GetExtenList,
      callback);
};


/**
 * @param {!proto.xcommon.XExtenListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ExtenListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.getExtenList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/GetExtenList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_GetExtenList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.XExtenListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_NxExtenManageService_GetExtenListExport = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/GetExtenListExport',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.XExtenListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.XExtenListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.XExtenListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.getExtenListExport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/GetExtenListExport',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_GetExtenListExport,
      callback);
};


/**
 * @param {!proto.xcommon.XExtenListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.getExtenListExport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/GetExtenListExport',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_GetExtenListExport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DelExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_DelExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/DelExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.DelExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.DelExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.DelExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.delExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/DelExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_DelExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.DelExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.delExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/DelExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_DelExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AddExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_AddExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/AddExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.AddExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.AddExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.AddExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.addExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AddExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AddExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.AddExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.addExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AddExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AddExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UpdateExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_UpdateExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/UpdateExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.UpdateExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.UpdateExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.UpdateExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.updateExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UpdateExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UpdateExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.UpdateExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.updateExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UpdateExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UpdateExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AssignExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_AssignExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/AssignExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.AssignExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.AssignExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.AssignExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.assignExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AssignExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AssignExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.AssignExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.assignExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AssignExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AssignExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.LockExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_LockExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/LockExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.LockExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.LockExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.LockExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.lockExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/LockExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_LockExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.LockExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.lockExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/LockExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_LockExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UnLockExtenPhoneReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_UnLockExtenPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/UnLockExtenPhone',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.UnLockExtenPhoneReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.UnLockExtenPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.UnLockExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.unLockExtenPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UnLockExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UnLockExtenPhone,
      callback);
};


/**
 * @param {!proto.xcommon.UnLockExtenPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.unLockExtenPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UnLockExtenPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UnLockExtenPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AssignHistoryReq,
 *   !proto.xcommon.AssignHistoryResp>}
 */
const methodDescriptor_NxExtenManageService_AssignHistory = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/AssignHistory',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.AssignHistoryReq,
  xcommon_nxExtenManage_pb.AssignHistoryResp,
  /**
   * @param {!proto.xcommon.AssignHistoryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_nxExtenManage_pb.AssignHistoryResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.AssignHistoryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.AssignHistoryResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.AssignHistoryResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.assignHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AssignHistory',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AssignHistory,
      callback);
};


/**
 * @param {!proto.xcommon.AssignHistoryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.AssignHistoryResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.assignHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/AssignHistory',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_AssignHistory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UnassignReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_NxExtenManageService_BatchUnAssignExtPhone = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/BatchUnAssignExtPhone',
  grpc.web.MethodType.UNARY,
  xcommon_dialer_pb.UnassignReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.UnassignReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.UnassignReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.batchUnAssignExtPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/BatchUnAssignExtPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_BatchUnAssignExtPhone,
      callback);
};


/**
 * @param {!proto.xcommon.UnassignReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.batchUnAssignExtPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/BatchUnAssignExtPhone',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_BatchUnAssignExtPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.UserAssignedListReq,
 *   !proto.xcommon.UserAssignedListResp>}
 */
const methodDescriptor_NxExtenManageService_UserAssignedList = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/UserAssignedList',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.UserAssignedListReq,
  xcommon_nxExtenManage_pb.UserAssignedListResp,
  /**
   * @param {!proto.xcommon.UserAssignedListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_nxExtenManage_pb.UserAssignedListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.UserAssignedListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.UserAssignedListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.UserAssignedListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.userAssignedList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UserAssignedList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UserAssignedList,
      callback);
};


/**
 * @param {!proto.xcommon.UserAssignedListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.UserAssignedListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.userAssignedList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/UserAssignedList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_UserAssignedList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OperateNxteleReq,
 *   !proto.xcommon.OperateNxteleResp>}
 */
const methodDescriptor_NxExtenManageService_OperateNxtele = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/OperateNxtele',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.OperateNxteleReq,
  xcommon_nxExtenManage_pb.OperateNxteleResp,
  /**
   * @param {!proto.xcommon.OperateNxteleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_nxExtenManage_pb.OperateNxteleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.OperateNxteleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.OperateNxteleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.OperateNxteleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.operateNxtele =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/OperateNxtele',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_OperateNxtele,
      callback);
};


/**
 * @param {!proto.xcommon.OperateNxteleReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.OperateNxteleResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.operateNxtele =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/OperateNxtele',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_OperateNxtele);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.NxteleListReq,
 *   !proto.xcommon.NxteleListResp>}
 */
const methodDescriptor_NxExtenManageService_NxteleList = new grpc.web.MethodDescriptor(
  '/dialerepb.NxExtenManageService/NxteleList',
  grpc.web.MethodType.UNARY,
  xcommon_nxExtenManage_pb.NxteleListReq,
  xcommon_nxExtenManage_pb.NxteleListResp,
  /**
   * @param {!proto.xcommon.NxteleListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_nxExtenManage_pb.NxteleListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.NxteleListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.NxteleListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.NxteleListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dialerepb.NxExtenManageServiceClient.prototype.nxteleList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/NxteleList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_NxteleList,
      callback);
};


/**
 * @param {!proto.xcommon.NxteleListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.NxteleListResp>}
 *     Promise that resolves to the response
 */
proto.dialerepb.NxExtenManageServicePromiseClient.prototype.nxteleList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dialerepb.NxExtenManageService/NxteleList',
      request,
      metadata || {},
      methodDescriptor_NxExtenManageService_NxteleList);
};


module.exports = proto.dialerepb;

